import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'gatsby';
import { Typography } from '../Typography';
import { LOCATION_URLS } from '../../urls';
import { StyledLinkList } from '../LinkList';
import { IconLink } from '../IconLink';

interface LocationNavigationProps {
  name: string;
  url: string;
  isArea?: boolean;
}

const StyledLocationNavigation = styled.div`
  ${({ theme: { space } }) => css`
    position: sticky;
    top: ${space.xl};
  `};
`;

const StyledHeading = styled(Typography)`
  ${({ theme: { space, borders } }) => css`
    padding-bottom: ${space.lg};
    margin-bottom: ${space.md};
    border-bottom: ${borders.default};
  `};
`;

const StyledSubHeading = styled(Typography)`
  ${({ theme: { space } }) => css`
    margin-bottom: ${space.md};

    a {
      text-decoration: none;
    }
  `};
`;

export const LocationNavigation: FC<LocationNavigationProps> = ({ name, url, isArea, ...rest }) => (
  <StyledLocationNavigation {...rest}>
    <StyledHeading component="h2" variant="titleMedium">
      Area information
    </StyledHeading>
    <StyledSubHeading component="h2" variant="titleSmall" color="brand">
      <Link to={url}>{name}</Link>
    </StyledSubHeading>
    <nav>
      <StyledLinkList as="ul">
        <li>
          <IconLink url={`${url}${LOCATION_URLS.soldData}`} label="Sold data" arrowLeft />
        </li>
        {isArea && (
          <>
            <li>
              <IconLink url={`${url}${LOCATION_URLS.schools}`} label="Schools" arrowLeft />
            </li>
            <li>
              <IconLink url={`${url}${LOCATION_URLS.transport}`} label="Transport" arrowLeft />
            </li>
          </>
        )}
        <li>
          <IconLink url={`${url}${LOCATION_URLS.councilTax}`} label="Council tax" arrowLeft />
        </li>
      </StyledLinkList>
    </nav>
  </StyledLocationNavigation>
);
